const videoFit = () => {
    const $videos = $("[data-video-fit]");
    let $video, $videoEl, videoOffset, w, h, ratio, fW, fH, fRatio, videoSelector;

    const resizeVideos = () => {
        $videos.each((index, target) => {
            $video = $(target);
            videoSelector = $video.attr("data-video-fit");
            if (videoSelector == "") videoSelector = "iframe";
            $videoEl = $video.find(videoSelector);
            if (!$videoEl.length) return;

            videoOffset = $video.attr("data-video-fit-offset");
            if (videoOffset) {
                videoOffset = videoOffset.split(",");
            } else {
                videoOffset = [0.5];
            }

            w = $video.outerWidth();
            h = $video.outerHeight();
            ratio = w/h;
            fW = $videoEl.attr("width") ?? $videoEl.outerWidth();
            fH = $videoEl.attr("height") ?? $videoEl.outerHeight();
            fRatio = fW/fH;

            if (w == 0) return;

            if (fRatio > ratio) {
                $videoEl.css({
                    width: h * fRatio,
                    height: h,
                    transform: `translateX(${ - (h * fRatio - w) * parseFloat(videoOffset[0]) }px)`,
                });
            } else {
                $videoEl.css({
                    width: w,
                    height: w / fRatio,
                    transform: `translateY(${ - (w / fRatio - h) * parseFloat((videoOffset[1] ?? videoOffset[0])) }px)`,
                })
            }
        });
    }

    resizeVideos();
    $(window).on("resize", resizeVideos);
}

$(() => {
    setTimeout(videoFit, 500);
});

export default videoFit;
